// extracted by mini-css-extract-plugin
export var adminLinkTag = "_g-1q";
export var assigneePill = "_g-2m";
export var assigneesList = "_g-2l";
export var automationCard = "_g-50";
export var automationDetails = "_g-52";
export var automationLabel = "_g-54";
export var automationList = "_g-4z";
export var automationNotConfigured = "_g-56";
export var automationRow = "_g-53";
export var automationTitle = "_g-51";
export var automationValue = "_g-55";
export var backButton = "_g-1n";
export var cancelButton = "_g-24";
export var cardLabel = "_g-4h";
export var cardValue = "_g-4i";
export var configActions = "_g-6s";
export var configAssignee = "_g-5t";
export var configAssigneeDept = "_g-5v";
export var configAssigneeName = "_g-5u";
export var configAssignees = "_g-5s";
export var configContent = "_g-5f";
export var configDeactivateButton = "_g-6t";
export var configDeleteButton = "_g-6u";
export var configEmpty = "_g-5e";
export var configHeader = "_g-5g";
export var configLabel = "_g-5l";
export var configLabelWithIcon = "_g-5m";
export var configLoading = "_g-5d";
export var configNotes = "_g-5w";
export var configRow = "_g-5k";
export var configSection = "_g-5i";
export var configSectionTitle = "_g-5j";
export var configStatusCard = "_g-5p";
export var configStatusRow = "_g-5o";
export var configStep = "_g-5y";
export var configStepCount = "_g-61";
export var configStepHeader = "_g-5z";
export var configStepName = "_g-60";
export var configStepSkipped = "_g-65";
export var configStepSkippedBadge = "_g-66";
export var configStepsList = "_g-5x";
export var configSubstep = "_g-63";
export var configSubstepSkipped = "_g-64";
export var configSubsteps = "_g-62";
export var configValue = "_g-5n";
export var confirmButton = "_g-25";
export var contentGrid = "_g-37";
export var contentLoading = "_g-1j";
export var coverageDetails = "_g-4k";
export var coverageSection = "_g-4j";
export var dealSizeField = "_g-2g";
export var dealSizeInput = "_g-2f";
export var dealSizeSaveButton = "_g-2h";
export var deleteModal = "_g-6v";
export var detailPanelsContainer = "_g-2j";
export var detailsGrid = "_g-i";
export var dollarSign = "_g-2e";
export var editButton = "_g-2i";
export var editConfigButton = "_g-5h";
export var emptyState = "_g-j";
export var emptyStateText = "_g-l";
export var emptyStateTitle = "_g-k";
export var emptyText = "_g-4d";
export var errorContainer = "_g-1i";
export var expandButton = "_g-3e";
export var gridCard = "_g-4g";
export var headerActions = "_g-1v";
export var headerTags = "_g-1p";
export var hubspotLink = "_g-5q";
export var hubspotLinkTag = "_g-1t";
export var hubspotLinkText = "_g-5r";
export var infoCard = "_g-4c";
export var kpiDivider = "_g-2d";
export var kpiItem = "_g-29";
export var kpiLabel = "_g-2a";
export var kpiRow = "_g-27";
export var kpiSpacer = "_g-28";
export var kpiValue = "_g-2c";
export var kpiValueContainer = "_g-2b";
export var leftColumn = "_g-38";
export var loadMoreButton = "_g-36";
export var loadMoreContainer = "_g-35";
export var loadingContainer = "_g-1h";
export var loadingIcon = "_g-1k";
export var loadingIconSmall = "_g-5c";
export var metaSection = "_g-1m";
export var notStartedTag = "_g-1r";
export var notePill = "_g-47";
export var notePillHeader = "_g-48";
export var notePillStep = "_g-49";
export var notePillText = "_g-4b";
export var notePillTimestamp = "_g-4a";
export var notesGrid = "_g-46";
export var oeConfigLabel = "_g-69";
export var oeConfigRow = "_g-68";
export var oeConfigValue = "_g-6a";
export var oeEditWindowGroup = "_g-67";
export var oePlatformsList = "_g-6n";
export var oeProgressBadge = "_g-6o";
export var oeStepItem = "_g-6q";
export var oeStepItemCompleted = "_g-6r";
export var oeStepsList = "_g-6p";
export var oeSubOption = "_g-6j";
export var oeSubOptionActive = "_g-6k";
export var oeSubOptionDot = "_g-6m";
export var oeSubOptionIcon = "_g-6l";
export var oeSubOptions = "_g-6i";
export var oeToolDuration = "_g-6g";
export var oeToolHeader = "_g-6e";
export var oeToolItem = "_g-6c";
export var oeToolItemEnabled = "_g-6d";
export var oeToolName = "_g-6f";
export var oeToolToggle = "_g-6h";
export var oeToolsList = "_g-6b";
export var pageContainer = "_g-1g";
export var pageTitle = "_g-1o";
export var pageWrapper = "_g-0";
export var paymentCard = "_g-4q";
export var paymentLabel = "_g-4s";
export var paymentRow = "_g-4r";
export var paymentValue = "_g-4t";
export var portalCard = "_g-4u";
export var portalLabel = "_g-4w";
export var portalLogo = "_g-4y";
export var portalRow = "_g-4v";
export var portalValue = "_g-4x";
export var preInstallBadge = "_g-1s";
export var productNavBar = "_g-3";
export var productStatusDot = "_g-6";
export var productStatusDotComplete = "_g-7";
export var productStatusDotHelpRequested = "_g-b";
export var productStatusDotInProgress = "_g-8";
export var productStatusDotNotStarted = "_g-a";
export var productStatusDotReopened = "_g-9";
export var productTab = "_g-4";
export var productTabActive = "_g-5";
export var progressBar = "_g-3l";
export var progressBarFill = "_g-3m";
export var progressCard = "_g-3f";
export var progressCircle = "_g-o";
export var progressCircleBg = "_g-p";
export var progressCircleFill = "_g-q";
export var progressCircleText = "_g-r";
export var progressLabel = "_g-3h";
export var progressMeta = "_g-3g";
export var progressPercent = "_g-3n";
export var progressStats = "_g-3i";
export var progressSubvalue = "_g-3k";
export var progressSummary = "_g-m";
export var progressSummaryDetail = "_g-v";
export var progressSummaryInfo = "_g-s";
export var progressSummaryMain = "_g-n";
export var progressSummarySubtitle = "_g-u";
export var progressSummaryTitle = "_g-t";
export var progressValue = "_g-3j";
export var pushActions = "_g-20";
export var pushButton = "_g-1x";
export var pushButtonContainer = "_g-1w";
export var pushButtonSuccess = "_g-1z";
export var pushDateInfo = "_g-2p";
export var pushDateText = "_g-1y";
export var pushToggle = "_g-22";
export var pushTogglesContainer = "_g-21";
export var pushWarning = "_g-2n";
export var pushWarningPill = "_g-2o";
export var replayLinkTag = "_g-1u";
export var returnFlowCard = "_g-57";
export var returnFlowStat = "_g-59";
export var returnFlowStatLabel = "_g-5a";
export var returnFlowStatValue = "_g-5b";
export var returnFlowSummary = "_g-58";
export var rightColumn = "_g-39";
export var section = "_g-3a";
export var sectionCheckbox = "_g-3d";
export var sectionHeader = "_g-3b";
export var sectionTitle = "_g-3c";
export var selectAllButton = "_g-23";
export var sessionBadge = "_g-26";
export var sessionButton = "_g-34";
export var sessionDate = "_g-2z";
export var sessionInfo = "_g-2x";
export var sessionItem = "_g-2v";
export var sessionItemActive = "_g-2w";
export var sessionMeta = "_g-30";
export var sessionMetaItem = "_g-31";
export var sessionMetaLabel = "_g-32";
export var sessionMetaValue = "_g-33";
export var sessionTitle = "_g-2y";
export var sessionsButton = "_g-2k";
export var sessionsContainer = "_g-2q";
export var sessionsEmpty = "_g-2t";
export var sessionsHeader = "_g-2r";
export var sessionsList = "_g-2u";
export var sessionsLoading = "_g-2s";
export var spin = "_g-1l";
export var stepCard = "_g-x";
export var stepCardCircle = "_g-12";
export var stepCardCircleComplete = "_g-14";
export var stepCardCirclePartial = "_g-13";
export var stepCardComplete = "_g-y";
export var stepCardCount = "_g-16";
export var stepCardHeader = "_g-10";
export var stepCardPartial = "_g-z";
export var stepCardStatus = "_g-11";
export var stepCardSubsteps = "_g-17";
export var stepCardTitle = "_g-15";
export var stepDuration = "_g-3v";
export var stepHeader = "_g-3t";
export var stepItem = "_g-3p";
export var stepItemCompleted = "_g-3q";
export var stepItemExpanded = "_g-3s";
export var stepItemPartial = "_g-3r";
export var stepName = "_g-3u";
export var stepToggle = "_g-3w";
export var stepToggleOpen = "_g-3y";
export var stepTogglePlaceholder = "_g-3x";
export var stepsGrid = "_g-w";
export var stepsList = "_g-3o";
export var substepBullet = "_g-44";
export var substepCompleted = "_g-41";
export var substepDuration = "_g-45";
export var substepIcon = "_g-43";
export var substepItem = "_g-40";
export var substepName = "_g-42";
export var substepRow = "_g-18";
export var substepRowComplete = "_g-19";
export var substepRowDot = "_g-1b";
export var substepRowIcon = "_g-1a";
export var substepRowName = "_g-1c";
export var substepRowTime = "_g-1d";
export var substepsList = "_g-3z";
export var tab = "_g-f";
export var tabActive = "_g-g";
export var tabBar = "_g-e";
export var tabBarContainer = "_g-c";
export var tabBarContent = "_g-d";
export var tabContent = "_g-h";
export var tag = "_g-4o";
export var tagEmpty = "_g-4p";
export var tagLabel = "_g-4m";
export var tagList = "_g-4n";
export var tagSection = "_g-4l";
export var threeColGrid = "_g-4f";
export var topHeader = "_g-1";
export var topHeaderContent = "_g-2";
export var topHeaderLeft = "_g-1f";
export var topHeaderMain = "_g-1e";
export var twoColGrid = "_g-4e";